// DO NOT EDIT -- generated from fs/services/dx-objects/model.proto

import { DataTableDetail, UnnamedDataTable } from './datatables.proto';
import { DefinedEventDetail } from './definedevents.proto';
import { FunnelDetail, UnnamedFunnel } from './funnels.proto';
import { HeatmapDetail, UnnamedHeatmap } from './heatmaps.proto';
import { JourneyDetail, UnnamedJourney } from './journeys.proto';
import { MetricDetail, UnnamedMetric } from './metrics.proto';
import { ObjectType } from './modeltypes.proto';
import { NamedElementDetail } from './namedelements.proto';
import { UnnamedOverlay } from './overlays.proto';
import { PageDetail } from './pages.proto';
import { PropertyDetail } from './properties.proto';
import { RetentionMetricDetail, UnnamedRetentionMetric } from './retentionmetrics.proto';
import { SegmentDetail, UnnamedSegment } from './segments.proto';
import * as proactiveinsights from '../../api/proactiveinsights';
import * as protoauditstore from '../../gcloud/dstore/protoauditstore';
import * as protobuf from '../../../google/protobuf';
import * as search_settings from '../search-settings';
import * as segment from '../../api/segment';
import * as visualizationsettings from '../search-settings/visualizationsettings';

export interface AuthorizationResult {
  isAllowed: boolean;
}

export enum DashboardCardType {
  DASHBOARDS_CARD_TYPE_INVALID = 0,
  DASHBOARDS_CARD_TYPE_METRIC = 1,
  DASHBOARDS_CARD_TYPE_FUNNEL = 2,
  DASHBOARDS_CARD_TYPE_RETENTION = 3,
  DASHBOARDS_CARD_TYPE_HEATMAP = 4,
  DASHBOARDS_CARD_TYPE_PAGE_FLOW = 5,
  DASHBOARDS_CARD_TYPE_NOTE = 6
}

export interface Card {
  id: protobuf.int64;
  name: string;
  description: string;
  metadata: Metadata | null;
  /** @deprecated */
  trend?: visualizationsettings.TrendSettings | null;
  /** @deprecated */
  singleNumber?: visualizationsettings.SingleNumberSettings | null;
  note?: NoteSettings | null;
  /** @deprecated */
  conversionFunnel?: visualizationsettings.ConversionFunnelSettings | null;
  /** @deprecated */
  dimensionality?: visualizationsettings.DimensionalitySettings | null;
  pageFlow?: PageFlowSettings | null;
  metricId?: string;
  funnelId?: string;
  retentionId?: string;
  heatmapId?: string;
  /** Whether this is a canned dashboard card */
  isCanned: boolean;
  format: DxCardFormat;
  chartType: DxChartType;
  funnelMetricType: FunnelMetricType;
}

export namespace Card {
  /**
   * since querying differs on a per-visualization basis, all the related information
   * needed for querying is kept within a unique settings message.
   */
  export enum settings {
    /** @deprecated */
    trend = 5,
    /** @deprecated */
    singleNumber = 6,
    note = 7,
    /** @deprecated */
    conversionFunnel = 8,
    /** @deprecated */
    dimensionality = 9,
    pageFlow = 11,
    metricId = 12,
    funnelId = 13,
    retentionId = 16,
    heatmapId = 17
  }

  /**
   * since querying differs on a per-visualization basis, all the related information
   * needed for querying is kept within a unique settings message.
   */
  export function settings_oneof(m: Card): { opt: settings.conversionFunnel, val: visualizationsettings.ConversionFunnelSettings } | { opt: settings.dimensionality, val: visualizationsettings.DimensionalitySettings } | { opt: settings.funnelId, val: string } | { opt: settings.heatmapId, val: string } | { opt: settings.metricId, val: string } | { opt: settings.note, val: NoteSettings } | { opt: settings.pageFlow, val: PageFlowSettings } | { opt: settings.retentionId, val: string } | { opt: settings.singleNumber, val: visualizationsettings.SingleNumberSettings } | { opt: settings.trend, val: visualizationsettings.TrendSettings } | null {
    if (m.trend != null) { return { opt: settings.trend, val: m.trend } }
    if (m.singleNumber != null) { return { opt: settings.singleNumber, val: m.singleNumber } }
    if (m.note != null) { return { opt: settings.note, val: m.note } }
    if (m.conversionFunnel != null) { return { opt: settings.conversionFunnel, val: m.conversionFunnel } }
    if (m.dimensionality != null) { return { opt: settings.dimensionality, val: m.dimensionality } }
    if (m.pageFlow != null) { return { opt: settings.pageFlow, val: m.pageFlow } }
    if (m.metricId != null) { return { opt: settings.metricId, val: m.metricId } }
    if (m.funnelId != null) { return { opt: settings.funnelId, val: m.funnelId } }
    if (m.retentionId != null) { return { opt: settings.retentionId, val: m.retentionId } }
    if (m.heatmapId != null) { return { opt: settings.heatmapId, val: m.heatmapId } }
    return null;
  }
}

export interface Dashboard {
  id: protobuf.int64;
  name: string;
  description: string;
  metadata: Metadata | null;
  cards: protobuf.int64[];
  /** When the seat in the request last viewed the dashboard */
  lastViewed: protobuf.timestamp | null;
  /** Whether this is a canned dashboard */
  isCanned: boolean;
  isWip: boolean;
  /** Whether the seat in the request has starred the dashboard */
  starred: boolean;
  /** The ID of the overlay that has been saved to this dashboard. */
  unnamedOverlayId: string;
  visibility: protoauditstore.Visibility;
  /** CardObjects is only used when returning the Dashboard from SQL */
  cardObjects: Card[];
}

/** Create / update metadata */
export interface Metadata {
  /** created by user email */
  createdBy: string;
  /** timestamp of creation date */
  createdAt: protobuf.timestamp | null;
  /** updated by user email */
  updatedBy: string;
  /** timestamp of update */
  updatedAt: protobuf.timestamp | null;
  /** version number */
  version: number;
}

export interface NoteSettings {
  note: NoteContent[];
}

export enum NoteType {
  NOTE_INVALID = 0,
  NOTE_HEADER = 1,
  NOTE_PARAGRAPH = 2,
  NOTE_HORIZONTAL_RULE = 3
}

export interface NoteContent {
  type: NoteType;
  content: string;
}

export interface SpecMappings {
  specObjectMappings: search_settings.SpecObjectMappingRecord[];
}

/**
 * ObjectDeps is a generic container for dependencies of a requested object.
 * Includes the requested object, as well as any others referenced by the object.
 * TODO(mhooper) put these in order
 */
export interface ObjectDeps {
  segments: { [key: string]: SegmentDetail };
  definedEvents: { [key: string]: DefinedEventDetail };
  namedElements: { [key: string]: NamedElementDetail };
  pages: { [key: string]: PageDetail };
  funnels: { [key: string]: FunnelDetail };
  metrics: { [key: string]: MetricDetail };
  dashboards: { [key: string]: Dashboard };
  cards: { [key: string]: Card };
  journeys: { [key: string]: JourneyDetail };
  heatmaps: { [key: string]: HeatmapDetail };
  retentionMetrics: { [key: string]: RetentionMetricDetail };
  unnamedMetrics: { [key: string]: UnnamedMetric };
  unnamedRetention: { [key: string]: UnnamedRetentionMetric };
  unnamedFunnels: { [key: string]: UnnamedFunnel };
  unnamedJourneys: { [key: string]: UnnamedJourney };
  unnamedHeatmaps: { [key: string]: UnnamedHeatmap };
  unnamedSegments: { [key: string]: UnnamedSegment };
  unnamedOverlays: { [key: string]: UnnamedOverlay };
  spaces: { [key: string]: Space };
  specMappings: { [key: string]: SpecMappings };
  specs: { [key: string]: search_settings.Spec };
  relatedSpaces: { [key: string]: RelatedSpace };
  properties: { [key: string]: PropertyDetail };
  dataTables: { [key: string]: DataTableDetail };
  unnamedDataTables: { [key: string]: UnnamedDataTable };
}

export interface PageFlowSettings {
  pageDefId: number;
  timeRange: segment.TimeRange | null;
  segment: visualizationsettings.SegmentSettings[];
  sameSession: boolean;
}

/** A section card is similar to a home card, but used in spaces */
export interface SectionCard {
  orgId: string;
  id: string;
  sectionId: string;
  /** indicates the size: 1 - small, 2 - medium, 3 - large */
  format: number;
  /** 1 - line, 2 - bar, 3 - single number, 4 - playlist, 5 - name, 6 - text */
  chartType: number;
  funnelMetricType: number;
  /** specifies the order of the cards within the section */
  index: number;
  object: SpaceObject | null;
  markdown: string;
}

export interface SidebarSpace {
  space: Space | null;
  dashboards: Dashboard[];
  funnels: FunnelDetail[];
  metrics: MetricDetail[];
  retentionMetrics: RetentionMetricDetail[];
  segments: SegmentDetail[];
  heatmaps: HeatmapDetail[];
  journeys: JourneyDetail[];
  totalRecords: SidebarSpace.TotalRecords | null;
}

export namespace SidebarSpace {
  export interface TotalRecords {
    dashboards: number;
    funnels: number;
    metrics: number;
    retentionMetrics: number;
    segments: number;
    heatmaps: number;
    journeys: number;
  }
}

/** A space is made up of sections with cards in each section */
export interface Space {
  orgId: string;
  id: string;
  name: string;
  description: string;
  /** hex color representing the spaces */
  color: string;
  isDefault: boolean;
  recentViewers: SpaceUser[];
  lastUpdated: protobuf.timestamp | null;
}

export interface ObjectIdWithType {
  id: string;
  type: ObjectType;
}

export interface RelatedSpace {
  space: Space | null;
  objects: ObjectIdWithType[];
}

export enum SpaceLibraryFilter {
  SPACES_FILTER_ACTIVE = 0,
  SPACES_FILTER_ARCHIVED = 1,
  SPACES_FILTER_OBJECT_ALL = 2,
  SPACES_FILTER_OBJECT_DASHBOARDS = 3,
  SPACES_FILTER_OBJECT_FUNNELS = 4,
  SPACES_FILTER_OBJECT_METRICS = 5,
  SPACES_FILTER_OBJECT_RETENTION_METRICS = 6,
  SPACES_FILTER_OBJECT_SEGMENTS = 7,
  SPACES_FILTER_OBJECT_HEATMAPS = 8,
  SPACES_FILTER_OBJECT_JOURNEYS = 9,
  SPACES_FILTER_OBJECT_DATA_TABLES = 16,
  SPACES_FILTER_CREATED_BY_ME = 10,
  SPACES_FILTER_STARRED = 11,
  SPACES_FILTER_RECENT = 12,
  /** Returns private objects owned by the current user. */
  SPACES_FILTER_PRIVATE = 13,
  SPACES_FILTER_PUBLIC = 14,
  /** Returns public and owned private objects */
  SPACES_FILTER_PUBLIC_OR_OWNED = 15,
  SPACES_FILTER_HAS_INSIGHTS = 17
}

export interface SpaceObjectOrder {
  by: SpaceObjectOrder.By;
  direction: SpaceObjectOrder.Direction;
}

export namespace SpaceObjectOrder {
  export enum By {
    /** This is the default sort. It is important to be field 0 so that it is the zero value of the enum. */
    BY_DEFAULT = 0,
    BY_NAME = 1,
    BY_LAST_MODIFIED = 2,
    BY_CREATED_AT = 3,
    BY_METRIC_INSIGHT_COUNT = 4,
    BY_OWNING_SPACE_NAME = 5,
    BY_CREATED_BY = 6
  }

  export enum Direction {
    DIRECTION_DEFAULT = 0,
    DIRECTION_ASC = 1,
    DIRECTION_DESC = 2
  }
}

/** A space section is used to divide the space into logical groups with cards in each section. */
export interface SpaceSection {
  orgId: string;
  id: string;
  name: string;
  spaceId: string;
  /** specifies the order of the sections within the space */
  index: number;
  cards: SectionCard[];
}

export interface SpaceObject {
  orgId: string;
  dxObjectId: string;
  dxObjectType: ObjectType;
  dashboard?: Dashboard | null;
  funnel?: FunnelDetail | null;
  metric?: MetricDetail | null;
  retentionMetric?: RetentionMetricDetail | null;
  segment?: SegmentDetail | null;
  heatmap?: HeatmapDetail | null;
  journey?: JourneyDetail | null;
  dataTable?: DataTableDetail | null;
  owningSpace: Space | null;
  insights: proactiveinsights.Insight[];
  featuredIn: Space[];
  referencedIn: Space[];
  canOwn: AuthorizationResult | null;
}

export namespace SpaceObject {
  export enum dx_object {
    dashboard = 6,
    funnel = 7,
    metric = 8,
    retentionMetric = 9,
    segment = 10,
    heatmap = 11,
    journey = 12,
    dataTable = 20
  }

  export function dx_object_oneof(m: SpaceObject): { opt: dx_object.dashboard, val: Dashboard } | { opt: dx_object.dataTable, val: DataTableDetail } | { opt: dx_object.funnel, val: FunnelDetail } | { opt: dx_object.heatmap, val: HeatmapDetail } | { opt: dx_object.journey, val: JourneyDetail } | { opt: dx_object.metric, val: MetricDetail } | { opt: dx_object.retentionMetric, val: RetentionMetricDetail } | { opt: dx_object.segment, val: SegmentDetail } | null {
    if (m.dashboard != null) { return { opt: dx_object.dashboard, val: m.dashboard } }
    if (m.funnel != null) { return { opt: dx_object.funnel, val: m.funnel } }
    if (m.metric != null) { return { opt: dx_object.metric, val: m.metric } }
    if (m.retentionMetric != null) { return { opt: dx_object.retentionMetric, val: m.retentionMetric } }
    if (m.segment != null) { return { opt: dx_object.segment, val: m.segment } }
    if (m.heatmap != null) { return { opt: dx_object.heatmap, val: m.heatmap } }
    if (m.journey != null) { return { opt: dx_object.journey, val: m.journey } }
    if (m.dataTable != null) { return { opt: dx_object.dataTable, val: m.dataTable } }
    return null;
  }
}

export interface SpaceUser {
  email: string;
  firstName: string;
  lastName: string;
  lastViewedAt: protobuf.timestamp | null;
}

export enum VirtualObjectSize {
  SIZE_SMALL = 0,
  SIZE_MEDIUM = 1,
  SIZE_LARGE = 2
}

export enum VirtualObjectFormat {
  FORMAT_CARD = 0,
  FORMAT_PLAYLIST = 1
}

export enum FunnelMetricType {
  FUNNEL_METRIC_TYPE_INVALID = 0,
  FUNNEL_METRIC_TYPE_USER_COUNT = 1,
  FUNNEL_METRIC_TYPE_CONVERSION_RATE = 2,
  FUNNEL_METRIC_TYPE_TIME_TO_COMPLETE = 3
}

export enum DxCardFormat {
  FORMAT_INVALID = 0,
  FORMAT_SMALL = 1,
  FORMAT_MEDIUM = 2,
  FORMAT_LARGE = 3
}

export enum DxChartType {
  CHART_TYPE_INVALID = 0,
  CHART_TYPE_LINE_CHART = 1,
  CHART_TYPE_BAR_CHART = 2,
  CHART_TYPE_SINGLE_NUMBER = 3,
  CHART_TYPE_PLAYLIST = 4,
  CHART_TYPE_NAME = 5,
  CHART_TYPE_TEXT = 6,
  CHART_TYPE_HEATMAP = 7
}

export enum VirtualDashboardId {
  /** @deprecated */
  PAGE = 0,
  /** @deprecated */
  UNCAUGHT_EXCEPTION = 1,
  /** @deprecated */
  PERFORMANCE = 2,
  /** @deprecated */
  ENGAGEMENT = 3,
  /** @deprecated */
  NAMED_ELEMENT = 4,
  /** @deprecated */
  CUSTOM_EVENT = 6,
  CUSTOM_EVENT_OVERVIEW = 7,
  ERRORS_UNCAUGHT_EXCEPTION = 8,
  NAMED_ELEMENT_OVERVIEW = 9,
  PAGE_ENGAGEMENT = 10,
  /** @deprecated */
  PAGE_OVERVIEW = 11,
  PAGE_PERFORMANCE = 12,
  SESSION_REPLAY_ERROR = 5,
  ERRORS_CLICKS = 13,
  ERRORS_CONSOLE_ERRORS = 14,
  /** @deprecated */
  ERRORS_NETWORK = 15,
  ERRORS_UNCAUGHT_EXCEPTIONS = 16,
  ERRORS_NETWORK_ERRORS = 17,
  ERRORS_CLICK = 18,
  ERRORS_CONSOLE_ERROR = 19,
  ERRORS_NETWORK_ERROR = 20,
  USERS_USER = 21,
  PAGES_OVERVIEW = 22,
  FUNNELS_OVERVIEW = 23,
  FUNNELS_REVENUE = 24,
  TEMPLATE_GALLERY_ERROR_RATE_OVER_TIME = 25,
  TEMPLATE_GALLERY_TRAFFIC_BY_DEVICE_TYPE = 26,
  TEMPLATE_GALLERY_CORE_WEB_VITALS = 28,
  TEMPLATE_GALLERY_SPIKES_IN_FRUSTRATION = 29,
  TEMPLATE_GALLERY_WEEKLY_ACTIVE_USERS = 30,
  TEMPLATE_GALLERY_FRUSTRATION_SIGNALS_OVERVIEW = 31,
  TEMPLATE_GALLERY_FEATURE_ENGAGEMENT = 32,
  TEMPLATE_GALLERY_PRODUCT_MANAGER = 33,
  TEMPLATE_GALLERY_ORDERS_REVENUE = 34,
  TEMPLATE_GALLERY_UX_DESIGNER = 35,
  TEMPLATE_GALLERY_ISSUE_MONITORING = 37,
  TEMPLATE_GALLERY_MARKETING = 38,
  TEMPLATE_GALLERY_ECOM_FUNNEL = 39,
  TEMPLATE_GALLERY_PURCHASE_FLOW_ISSUES = 40,
  /** @deprecated */
  INSIGHT_SINGLE = 41,
  /** @deprecated */
  INSIGHT_DUAL = 42,
  TEMPLATE_GALLERY_WEB_CAPTURE_CONFIGURATION_GUIDE = 43,
  INSIGHT_OVERVIEW = 44,
  INSIGHT_IMPACT = 45,
  INSIGHT_DIAGNOSTIC = 46,
  CANNED_WELCOME = 47,
  INSIGHT_FUNNEL_ERROR = 48
}

export interface VirtualObject {
  metric?: search_settings.Metric | null;
  note?: NoteSettings | null;
  funnel?: search_settings.Funnel | null;
  retentionMetric?: search_settings.RetentionMetric | null;
  size: VirtualObjectSize;
  format: VirtualObjectFormat;
  funnelMetricType: FunnelMetricType;
}

export namespace VirtualObject {
  export enum definition {
    metric = 1,
    note = 4,
    funnel = 5,
    retentionMetric = 7
  }

  export function definition_oneof(m: VirtualObject): { opt: definition.funnel, val: search_settings.Funnel } | { opt: definition.metric, val: search_settings.Metric } | { opt: definition.note, val: NoteSettings } | { opt: definition.retentionMetric, val: search_settings.RetentionMetric } | null {
    if (m.metric != null) { return { opt: definition.metric, val: m.metric } }
    if (m.note != null) { return { opt: definition.note, val: m.note } }
    if (m.funnel != null) { return { opt: definition.funnel, val: m.funnel } }
    if (m.retentionMetric != null) { return { opt: definition.retentionMetric, val: m.retentionMetric } }
    return null;
  }
}

export interface VirtualDashboard {
  objects: VirtualObject[];
}

/**
 * DashboardWithCards wraps a dashboard and its cards.
 * This wrapper is sent into the pubsub object-update-queue when a dashboard or card is updated.
 * Needed because the entire dashboard (and all its cards)
 * are required to correctly update the dashboard's references.
 */
export interface DashboardWithCards {
  dashboard: Dashboard | null;
  cards: Card[];
}
